<template>
  <div fluid class="full-screen-background">
    <v-container>
      <v-row>
        <v-col>
          <h1>
            <span style="color:#03A9F4;">专业</span>
            <span>信赖，</span>
            <span style="color:#03A9F4;">携手</span>
            <span>成长</span>
          </h1>
          <p>以信为本 以诚立业 规范务实 追求专业</p>
        </v-col>
      </v-row>

      <!-- 右下角的行业链接区域 -->
      <v-row class="fixed-bottom-right">
        <v-col cols="auto">
          <v-card class="news-card" width="450" height="300" outlined>
            <v-card-title>行业动态</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="(link, index) in links" :key="index" :href="link.url" target="_blank">
                  {{ link.title }}
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const links = ref([
  {
    title: '关于调整铁路和航空运输企业汇总缴纳增值税分支机构名单的通知',
    url: 'https://shanghai.chinatax.gov.cn/zcfw/zcfgk/zzs/202605/t480317.html'
  },
  {
    title: '关于开展2026社保年度用人单位社会保险缴费工资申报工作的通告',
    url: 'https://shanghai.chinatax.gov.cn/zcfw/zcfgk/sbf/202604/t480144.html'
  },
  {
    title: '银行函证电子平台接入会计师事务所和金融机构公告',
    url: 'https://www.cicpa.org.cn/xxfb/tzgg/202604/t20260403_65898.html'
  },
  {
    title: '关于延长《上海市地方教育附加征收管理办法》有效期的通知',
    url: 'https://shanghai.chinatax.gov.cn/zcfw/zcfgk/fssr/202604/t480141.html'
  }
])

</script>

<style scoped>
p {
  padding-left: 10px;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.5;
  color: gray;
}

h1 {
  padding: 20px 30px 20px 0px;
  font-size: 4rem;
  font-weight: bold;
  color: #E1F5FE;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.full-screen-background {
  background-image: url('/public/assets/img/GGI1_c12a2c12a2c12a2c.png');
  background-size: cover;
  background-position: center;
  background-color: #f8f9fa;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: calc(100vh - 104px);
  width: 100vw;
  padding: 0;
  margin: 0;
}

.fixed-bottom-right {
  position: fixed;
  bottom: 60px;
  left: 20px;
}

.news-card {
  background: rgba(255, 255, 255, 0.8);
  /* 半透明背景 */
  backdrop-filter: blur(10px);
  /* 磨砂效果 */
  border-radius: 8px;
  /* 圆角 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.v-list {
  background: none;
}
</style>